import VectorPrimitive from './VectorPrimitive.js';

class Annotation extends VectorPrimitive {
  constructor(options) {
    super(options);
  }

  /**
   * 获取Label
   * @override
   * @param {Cesium.Entity} entity
   * @returns {string?}
   */
  _getLabel(entity) {
    const extendedData = entity.kml?.extendedData;
    if (extendedData) {
      let text = '';
      if (extendedData.name) {
        text += extendedData.name.value ?? null;
      }
      // 仅面标注显示value信息
      if (entity.polygon && extendedData.value) {
        text += `\n${extendedData.value.value ?? null}`;
      }
      return text;
    }
    if (entity.name) {
      return entity.name;
    }
    return null;
  }
}

export default Annotation;
